import React, { memo, useState, useCallback } from "react";
import {
  IconButton,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "investira.react.components";
import { useSelector, useDispatch } from "react-redux";
import withResponseHandling from "../../hoc/withResponseHandling";
import CalendarPosicoes from "./CalendarPosicoes";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import { acCarteiraSelected } from "../../store/actions";
import usePerfil from "../../hooks/usePerfil";

const CalendarPosicoesDialog = memo((props) => {
  const storeCarteiraCurrent = useSelector((store) => store.carteiras.current);
  const storeDispatch = useDispatch();

  const { state, actions } = useCarteirasContext();
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("S");
  const [dataPosicao, setDataPosicao] = useState(state.data_posicao);

  const { usuarioPrioridade } = usePerfil();

  const CONFIRM_TIPO = {
    S: {
      value: "S",
      label: "Selecionar",
      action: (pParams) => {
        const { carteira_id, data } = pParams;
        const xDataPosicao = data.format();

        storeDispatch(
          acCarteiraSelected({
            ...storeCarteiraCurrent,
            data_posicao: xDataPosicao,
          })
        );

        actions.readPosicoes(
          { carteira_id, data: xDataPosicao },
          (rRes) => {
            actions.handleSetDataPosicao(xDataPosicao);
            actions.handleBulkAddPosicoes(rRes.data);
          },
          (rErr) => {
            props.responseErrorHandling(rErr);
          },
          () => {
            setOpen(false);
          }
        );
      },
    },
    N: {
      value: "N",
      label: "Criar Posição",
      action: (pParams) => {
        const { data } = pParams;
        const xDataPosicao = data.format();

        storeDispatch(
          acCarteiraSelected({
            ...storeCarteiraCurrent,
            data_posicao: xDataPosicao,
          })
        );

        actions.handleSetDataPosicao(xDataPosicao);
        actions.handleBulkAddPosicoes([]);
        setOpen(false);
      },
    },
  };

  const handleChange = ({ data, tipo }) => {
    setDataPosicao(data);
    const xTipo = usuarioPrioridade > 6 ? "S" : tipo;
    setConfirm(xTipo);
  };

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <React.Fragment>
      <IconButton variant="outlined" onClick={handleClickOpen}>
        <Icon iconName="calendar" color="primary" size={21} />
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Selecione a data da posição</DialogTitle>
        <DialogContent>
          <CalendarPosicoes
            key="calendar-posicoes"
            carteiraId={state.carteira_id}
            dataPosicao={state.data_posicao}
            datasPosicoes={state.datas_posicoes}
            onClose={handleClose}
            onChange={handleChange}
            refreshHighlightedDays={true}
            open={open}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            type="button"
            onClick={() =>
              CONFIRM_TIPO[confirm].action({
                carteira_id: state.carteira_id,
                data: dataPosicao,
              })
            }
          >
            {CONFIRM_TIPO[confirm].label}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

CalendarPosicoesDialog.displayName = "CalendarPosicoesDialog";

export default withResponseHandling(CalendarPosicoesDialog);
